export const HAWAII_TRAILS_API = process.env.REACT_APP_SERVER_URL; // api
export const HONOLULU = [-157.858333, 21.306944]; // lng/lat for some reason
